import React from 'react';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import ProgramsSection from './components/ProgramsSection';
import WhyChooseUs from './components/WhyChooseUs';
import GallerySection from './components/GallerySection';
import AdmissionsSection from './components/AdmissionsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <AboutSection />
      <ProgramsSection />
      <WhyChooseUs />
      <GallerySection />
      <AdmissionsSection />
      <ContactSection />
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
